/* Opt-in dependent native options. Shopify variant JSON remains authoritative. */
(function () {
  'use strict';

  function normalizeSelection(variants, selection) {
    const result = [];
    for (let index = 0; index < selection.length; index += 1) {
      const candidates = variants.filter((variant) => result.every((value, i) => variant.options[i] === value));
      const values = [...new Set(candidates.map((variant) => variant.options[index]))];
      result.push(values.includes(selection[index]) ? selection[index] : values[0]);
    }
    return result;
  }

  function allowedValues(variants, selection, index) {
    return new Set(variants.filter((variant) => selection.slice(0, index).every((value, i) => variant.options[i] === value))
      .map((variant) => variant.options[index]));
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { normalizeSelection, allowedValues };
    return;
  }

  if (customElements.get('catalog-dependent-options')) return;
  customElements.define('catalog-dependent-options', class extends HTMLElement {
    connectedCallback() {
      customElements.whenDefined('variant-selects').then(() => {
        if (!this.isConnected) return;
        const picker = document.getElementById(this.dataset.picker);
        if (!picker || picker.dataset.dependentOptionsReady) return;
        const selects = Array.from(picker.querySelectorAll('select'));
        const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
        if (selects.length < 2 || !variants.length || variants.some((variant) => variant.options.length !== selects.length)) return;
        picker.dataset.dependentOptionsReady = 'true';

        const normalize = () => {
          const selection = normalizeSelection(variants, selects.map((select) => select.value));
          selects.forEach((select, index) => { select.value = selection[index]; });
          return selection;
        };
        const refreshChoices = () => {
          const selection = selects.map((select) => select.value);
          selects.forEach((select, index) => {
            const allowed = allowedValues(variants, selection, index);
            Array.from(select.options).forEach((option) => {
              option.hidden = !allowed.has(option.value);
              option.disabled = option.hidden;
              option.textContent = option.value;
            });
          });
        };

        // Capture runs before Dawn's bubbling handler: it receives a real tuple
        // and updates price, cart ID, URL and gallery through its native methods.
        picker.addEventListener('change', (event) => {
          if (!selects.includes(event.target)) return;
          normalize();
          refreshChoices();
        }, true);
        picker.updateVariantStatuses = refreshChoices;
        normalize();
        refreshChoices();
      });
    }
  });
})();
